module.exports = __webpack_public_path__ + "img/20180815_150119_047.fb80eb55.jpg";